import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NotificationCellComponent } from './notification-cell.component';

@NgModule({
  declarations: [NotificationCellComponent],
  exports: [NotificationCellComponent],
  imports: [CommonModule],
})
export class NotificationCellModule {}
